export default __webpack_public_path__ + "static/media/060d36fe0cb7dfb06d8f71391107f8781600269412511.1fbefda2.webp";